import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators, FormArray } from '@angular/forms';
import { Biblio } from 'src/app/models/obs/biblio';
import { BiblioService } from 'src/app/services/obs/biblio.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UserLogService } from 'src/app/services/user-log.service';
import { UtilLogService } from 'src/app/services/util/util-log.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';

@Component({
  selector: 'app-admbiblio-block-form',
  templateUrl: './admbiblio-block-form.component.html',
  styleUrl: './admbiblio-block-form.component.scss'
})
export class AdmbiblioBlockFormComponent implements OnInit {

  biblio: Biblio = null;
  idtier3Selected: string = null;
  isBlockedTier3: boolean = false

  constructor(
    private t3Service: Tier3Service,
    private router: Router,
    private biblioS: BiblioService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private tokenStorage: TokenStorageService,
    private userLogService: UserLogService,
    private utilLogservice: UtilLogService,
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.getLastOrderSubsection();
    this.getIsBlockedTier3(params['id']);
  }

  getIsBlockedTier3(id: number) {
    this.t3Service.idT3blocked(id).subscribe({
      next: res => { this.isBlockedTier3 = res['isblocked']; },
      error: err => { console.log(err); }
    })
  }

  orderLastBibliography: number = 1;
  getLastOrderSubsection() {
    this.idtier3Selected = this.activedRoute.snapshot.params['idtier3'];
    this.biblioS.getOrderLast4T3Adm(this.idtier3Selected).subscribe({
      next: res => {
        if (res['status'] == 'OK') {
          this.orderLastBibliography = res['data'].order
        }
        if (res['status'] == 'ERROR') {
          this.orderLastBibliography = 0;
        }
      },
      error: err => { }
    })
  }

  /* Incio codigo FormArray */

  fatherForm = this.fb.group({
    textbox: ['', Validators.required],
    dataset: this.fb.array([])
  })

  get dataset() {
    return this.fatherForm.get('dataset') as FormArray;
  }

  get textbox() {
    return this.fatherForm.get('textbox');
  }

  removerCampos() {
    this.dataset.clear();
  }

  tempInfo: string[];
  modelChangefn(event) {
    this.removerCampos();
    this.tempInfo = this.textbox.value.split('\n')
    this.loadInfo(this.tempInfo);
  }

  loadInfo(bibliography: Array<any>) {
    let formArray = this.dataset;
    let contOrder = 0;
    for (let i = 0; i < bibliography.length; i++) {
      if (bibliography[i] !== '') {
        const urlMatch = bibliography[i].match(/https?:\/\/[^\s]+/);
        const urlsource = urlMatch ? urlMatch[0] : null;
        formArray.push(
          this.fb.group({
            id: null,
            idtier3: this.activedRoute.snapshot.params['idtier3'],
            order: contOrder + this.orderLastBibliography + 1,
            content: [bibliography[i]],
            urlsource: urlsource,
            touchedBy: this.tokenStorage.getUser().nombre,
            status: true,
          })
        )
        contOrder = contOrder + 1;
      }
    }
    /* console.log("Esto esta en array : ", (formArray.value)); */
  }

  /* Fin  codigo FormArray */

  dataLog = {};
  submit() {
    if (confirm('Se crearán ' + this.dataset.value.length + ' citas bibliográficas. ¿Está de acuerdo?')) {

      for (let i = 0; i < this.dataset.value.length; i++) {
        this.biblio = this.dataset.value[i]

        this.biblioS.create(this.biblio).subscribe({
          next: res => {
            // Crear el log de actividad del usuario
            if (res) this.utilLogservice.createLog(res['data'], 'creación', 'bibliografia');
            if (i + 1 == this.dataset.value.length) {
              this.router.navigate(['/adm/bibliografia/list/', this.idtier3Selected]);
            }
          },
          error: err => { console.error(err) }
        })
      }
    }
  }

  cancel() {
    this.router.navigate(['/adm/bibliografia/list/', this.idtier3Selected]);
  }

}
